import { lazy, Suspense, type FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import Home from '@/pages/Home/Home';
import Example from '@/pages/Example';
import Login from '@/pages/Login/Login';

const NotFound = lazy(() => import('@/pages/NotFound/NotFound'));

const RouteLoading: FC = () => null;

const App: FC = () => {
  return (
    <>
      <Header />
      <Suspense fallback={<RouteLoading />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/example" element={<Example />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
};

export default App;
